import React from 'react';

import { Typography } from '@mui/material';

import RBAC from '@common/components/RBAC';

import useChatTitle from '../utils/useChatTitle';
import ChannelListHeaderDescription from './Description';
import ChatLastActivity from './LastActivity';
import ChannelListHeaderWorkTimeInfo from './WorkTimeInfo';
import * as Styled from './styled';

function ChannelListHeader() {
	const chatName = useChatTitle();

	return (
		<Styled.Wrap>
			<Styled.Info>
				<Styled.TitleWrap>
					<Typography variant="subtitle1">{chatName}</Typography>
				</Styled.TitleWrap>
				<RBAC grantedOnly granted={['Mentor/Tutor', 'Teacher']}>
					<ChatLastActivity />
				</RBAC>
				<ChannelListHeaderWorkTimeInfo />
			</Styled.Info>
			<ChannelListHeaderDescription />
		</Styled.Wrap>
	);
}

export default ChannelListHeader;
